module.exports = __webpack_public_path__ + "static/fronds-2d764b02d411b154de984b6412d69ccb.png";